import { UserRoles } from '@/enums';
import { LeadsStatuses } from '@/enums/statuses/leads';
import { ApiPagination, TableFilterItem, SimpleEnumType } from '@/types';

export namespace Leads {
  export enum Pages {
    LEADS = 'leads',
    LEAD_DETAIL = 'lead',
  }

  export type ResponseLeadReminder = {
    [key: string]: unknown,
    reminder_id: number,
    reminder_date: string,
    user_id: number
  }

  export interface RequestFilters {
    [key: string]: unknown,
    search: string,
    status: number | null,
    categories: number | null,
    dates: string[],
    region: string | null,
    types: string[] | null,
  }

  export interface TableFilters {
    statuses: TableFilterItem[],
    categories: TableFilterItem[],
    regions: string[],
    types: string[],
  }

  export interface ItemLog {
    comment: string,
    user_name: string,
    user_role: string,
    date: string
  }

  export interface Item {
    [key: string]: unknown,
    id: string | number,
    date: string,
    last_modified_date: string,
    number: string,
    status_slug: keyof LeadsStatuses | null,
    status_name: string | null,
    city: string | null,
    region: string | null,
    phone: string | null,
    email: string | null,
    category: string | null,
    sale_amount: string | number | null,
    source: string | null,
    edited_by: string | null,
    last_comment: ItemLog | null,
    color: string | null,
    has_unread_change: boolean,
    type: string | null,
    reminder_date: string | null,
  }

  export interface Response extends ApiPagination {
    data: {
      items: Item[],
      filters: TableFilters,
    }
  }

  export type Lead = {
    [key: string]: unknown,
    id?: string | number,
    lead_date: string,
    last_modified_date: string,
    lead_number: string | number,
    company_name: string,
    author_appeal: string,
    external_id?: string,
    is_free?: boolean, // флаг "можно ли зайти в деталку лида"
    lead_status: SimpleEnumType<LeadsStatuses>,
    city: string,
    region: string,
    telephone: string,
    email: string,
    topic_of_appel: string,
    sale_amount?: string | number,
    source?: string,
    comment?: string,
    // eslint-disable-next-line no-use-before-define
    last_comment?: LeadLog | null,
    description?: string,
    edited_by_user: string | null,
    color?: string,
    is_editing_not_available: boolean,
    has_unread_change: boolean,
    lead_category_id: string | null,
    lead_category_name: string | null,
    type: string,
    reminders: ResponseLeadReminder[],
  }

  export interface LeadLog {
    id: number,
    user: {
      id: number,
      name: string,
      surname: string,
      patronymic: string | null,
      full_name: string,
      roles: SimpleEnumType<UserRoles.Internal>[]
    },
    lead_id?: number,
    lead_status: SimpleEnumType<LeadsStatuses>,
    old_lead_status: SimpleEnumType<LeadsStatuses>,
    comment: string | null,
    is_only_comment: boolean,
    created_at: string,
  }

  export type LeadCategory = {
    text: string,
    value: string,
  }

  export type LeadCategories = LeadCategory[] | null;

  export type UpdLeadPayload = {
    id: string | number,
    lead_status: string | number,
    comment?: string,
    sale_amount?: string | number | null,
    lead_category?: string | null
  }

  export type AvailableTransitionStatuses = {
    [key: string]: unknown,
    id: number
    slug: string
    name: string
    is_comment_required: boolean
    info_message: string | null
  }

  export type LeadReminder = {
    [key: string]: unknown,
    date: string,
    time: string,
    user_ids: number[],
  }

  export interface LeadResponse {
    item: Lead,
    categories: LeadCategories,
    available_transition_statuses: AvailableTransitionStatuses[],
    is_read_only: boolean
  }
}
